import { Popconfirm } from "antd";
import style from "./index.module.scss";
import { PopconfirmProps } from "antd/lib/popconfirm";
import React from "react";

interface PopConfirmProps extends PopconfirmProps {
    okText?: string;
    cancelText?: string;
    children: React.ReactNode;
}

export default function PopConfirm({
    okText = "确定",
    cancelText = "取消",
    children,
    ...restProps
}: PopConfirmProps) {
    return (
        <div className={style.root}>
            <Popconfirm okText={okText} cancelText={cancelText} {...restProps}>
                {children}
            </Popconfirm>
        </div>
    );
}
